import React, { ChangeEvent } from 'react';
import { Box, IconButton } from '@mui/material';
import styled from '@emotion/styled';
import AttachmentIcon from '@mui/icons-material/Attachment';
import { Row } from '../../../global/styledComponents';
import SendIcon from '@mui/icons-material/Send';
type ChatInputProps = {
    message: string;
    onMessageChange: (event: ChangeEvent<HTMLInputElement>) => void;
    onSendMessage: () => void;
}
const ChatIputNavbar = styled(Box)({
    display: "flex",
    alignItems: "center",
    background: "#eee",
    width: "100%",
    justifyContent: "center",
    borderTop: "1px solid #ccc",
    padding: ".5rem 1rem"
})
const StyledInput = styled.input`
  padding: 8px 12px;
  font-size: .85rem;
  border: 0;
  background:none;
  width:100%;
  border-radius: 4px;
  font-family:'Yekan !important';
  &:focus-visible {
    outline: unset;
    outline-offset: unset;
  }
`;
const ChatInput = ({ message, onMessageChange, onSendMessage, ...props }: ChatInputProps) => {
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            onSendMessage();
        }
    };
    return (
        <ChatIputNavbar >
            <Box
                width="100%"
                boxShadow={1}
                sx={{
                    bgcolor: "primary.light",
                    padding: "0 1rem",
                    borderRadius: "1rem",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                <StyledInput
                    type="text"
                    value={message}
                    onKeyDown={handleKeyDown}
                    //@ts-ignore
                    onChange={onMessageChange}
                    width="100%"
                    placeholder="ارسال پاسخ..."
                    contentEditable
                    {...props}
                />

                <Row width="fit-content">
                    <IconButton>
                        <AttachmentIcon onClick={() => console.log("send file")} />
                    </IconButton>
                    <IconButton onClick={onSendMessage}>
                        <SendIcon />
                    </IconButton>
                </Row>
            </Box>
        </ChatIputNavbar>
    );
};

export default ChatInput;
